import React from 'react';
import './Validation.scss';

export default (props) => {
  if (!props.errors || !props.errors.length) {
    return null;
  }

  if (props.errors.length > 1) {
    return (
      <ul className="validation-message">
        {props.errors.map((error, index) => <li key={index} className="validation-message__item">{error}</li>)}
      </ul>
    );
  }

  return (
    <div className="validation-message"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 11.8613C8.17 11.8613 8.3126 11.8037 8.4278 11.6885C8.543 11.5733 8.6004 11.4309 8.6 11.2613C8.6 11.0913 8.5424 10.9487 8.4272 10.8335C8.312 10.7183 8.1696 10.6609 8 10.6613C7.83 10.6613 7.6874 10.7189 7.5722 10.8341C7.457 10.9493 7.3996 11.0917 7.4 11.2613C7.4 11.4313 7.4576 11.5739 7.5728 11.6891C7.688 11.8043 7.8304 11.8617 8 11.8613ZM8 14.8613C7.17 14.8613 6.39 14.7037 5.66 14.3885C4.93 14.0733 4.295 13.6459 3.755 13.1063C3.215 12.5663 2.7876 11.9313 2.4728 11.2013C2.158 10.4713 2.0004 9.69133 2 8.86133C2 8.03133 2.1576 7.25133 2.4728 6.52133C2.788 5.79133 3.2154 5.15633 3.755 4.61633C4.295 4.07633 4.93 3.64893 5.66 3.33413C6.39 3.01933 7.17 2.86173 8 2.86133C8.83 2.86133 9.61 3.01893 10.34 3.33413C11.07 3.64933 11.705 4.07673 12.245 4.61633C12.785 5.15633 13.2126 5.79133 13.5278 6.52133C13.843 7.25133 14.0004 8.03133 14 8.86133C14 9.69133 13.8424 10.4713 13.5272 11.2013C13.212 11.9313 12.7846 12.5663 12.245 13.1063C11.705 13.6463 11.07 14.0739 10.34 14.3891C9.61 14.7043 8.83 14.8617 8 14.8613ZM8 9.46133C8.17 9.46133 8.3126 9.40373 8.4278 9.28853C8.543 9.17333 8.6004 9.03093 8.6 8.86133V6.46133C8.6 6.29133 8.5424 6.14873 8.4272 6.03353C8.312 5.91833 8.1696 5.86093 8 5.86133C7.83 5.86133 7.6874 5.91893 7.5722 6.03413C7.457 6.14933 7.3996 6.29173 7.4 6.46133V8.86133C7.4 9.03133 7.4576 9.17393 7.5728 9.28913C7.688 9.40433 7.8304 9.46173 8 9.46133Z" fill="#DE350B"/>
    </svg>
    {props.errors[0]}</div>
  );
}
